import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyCTA from "./components/StickyCTA";
import CookieBanner from "./components/CookieBanner";
import WelcomeBack from "./components/WelcomeBack";
import Home from "./pages/Home";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetail from "./pages/ServiceDetail";
import AboutPage from "./pages/AboutPage";
import AreaPage from "./pages/AreaPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

const SmoothScroll = () => {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);
    return null;
};

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <div className="noise-overlay" aria-hidden="true" />
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/servicios" element={<ServicesPage />} />
                    <Route path="/servicios/:slug" element={<ServiceDetail />} />
                    <Route path="/sobre-nosotros" element={<AboutPage />} />
                    <Route path="/zona-de-servicio" element={<AreaPage />} />
                    <Route path="/faq" element={<FAQPage />} />
                    <Route path="/contacto" element={<ContactPage />} />
                    <Route path="/aviso-legal" element={<LegalPage type="legal" />} />
                    <Route path="/privacidad" element={<LegalPage type="privacidad" />} />
                    <Route path="/cookies" element={<LegalPage type="cookies" />} />
                    <Route path="*" element={<Home />} />
                </Routes>
                <Footer />
                <StickyCTA />
                <CookieBanner />
                <WelcomeBack />
                <Toaster position="bottom-center" richColors />
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
